import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { ActionButtonDto, ReportDto } from "@api";

@Component({
  selector: "app-report-kpi",
  templateUrl: "./report-kpi.component.html",
  styleUrls: ["./report-kpi.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportKpiComponent {
  @Input() public actionButton: ActionButtonDto;
  @Input() public report: ReportDto;
}
